module.exports = __webpack_public_path__ + "img/9e56eaa48f7d46eb4ac290e9ffd0c8f5.png";